import React from 'react';
import {
  Modal as MuiModal,
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ModalDeleteProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  residentName: string;
}

export function ModalDelete({ open, onClose, onConfirm, loading, residentName }: ModalDeleteProps) {
  return (
    <MuiModal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-delete-title"
      aria-describedby="modal-delete-description"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <WarningAmberIcon color="error" sx={{ fontSize: 32 }} />
          <Typography id="modal-delete-title" variant="h6" component="h2">
            Confirmar Exclusão
          </Typography>
        </Box>

        <Typography id="modal-delete-description" sx={{ mb: 3 }}>
          Tem certeza que deseja excluir o morador <strong>{residentName}</strong>?
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Esta ação não pode ser desfeita.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Excluindo...' : 'Excluir'}
          </Button>
        </Box>
      </Box>
    </MuiModal>
  );
}